// extracted by mini-css-extract-plugin
module.exports = {"details":"_1IhsE","arrow":"_2y2yp","title":"_4GIa-","categoryLink":"_1D6nD","moreButton":"_3W2R_","statistics":"_2X6qb"};